import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { ActionButtonComponent } from "../ui-components/buttons/action-button/action-button.component";
import { ActionButtonType } from "../ui-components/buttons/action-button/action-button.model";
import { DropdownComponent } from "../ui-components/dropdown/dropdown.component";
import { DropdownOption } from "../ui-components/dropdown/dropdown.model";
import { FormInputComponent } from "../ui-components/forms/form-input/form-input.component";
import { FormInputType } from "../ui-components/forms/form-input/form-input.model";
import type { PosNotification } from "../../services/pos-notifications.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule, ActionButtonComponent, DropdownComponent, FormInputComponent],
  templateUrl: "./notification-dialog.component.html",
  styleUrls: ["./notification-dialog.component.scss"],
})
export class NotificationDialogComponent {
  readonly ActionButtonType = ActionButtonType;
  readonly FormInputType = FormInputType;
  value = "";
  readonly options: string[];
  readonly dropdownOptions: DropdownOption[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: PosNotification, private ref: MatDialogRef<NotificationDialogComponent>) {
    this.options = data.InputType === 2 ? (JSON.parse(data.AddionalJsonData ?? "{}").Options ?? []) : [];
    this.dropdownOptions = this.options.map(option => ({ label: option, value: option }));
  }

  get valid(): boolean {
    return this.data.DisplayType !== 1 || (this.data.InputType !== 1 && this.data.InputType !== 2) || (this.value.trim().length > 0 && (this.data.InputType !== 1 || this.value.length <= 512));
  }

  get color(): string { return this.data.DisplayType === 1 ? "green" : ["blue", "yellow", "red"][this.data.Importance] ?? "blue"; }
  get label(): string { return this.data.DisplayType === 1 ? "webPos.NotificationDialog" : ["webPos.NotificationInfo", "webPos.NotificationImportant", "webPos.NotificationCritical"][this.data.Importance] ?? "webPos.NotificationInfo"; }
  confirm(): void { if (this.valid) this.ref.close(this.data.DisplayType === 1 && (this.data.InputType === 1 || this.data.InputType === 2) ? this.value : null); }
}
